import { render } from "./main.vue?vue&type=template&id=6cdcbf9a"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=6cdcbf9a&lang=css"
script.render = render

export default script